import { render, staticRenderFns } from "./TotalWeeklyColumnProgress.vue?vue&type=template&id=d135ca36&scoped=true"
import script from "./TotalWeeklyColumnProgress.vue?vue&type=script&lang=js"
export * from "./TotalWeeklyColumnProgress.vue?vue&type=script&lang=js"
import style0 from "./TotalWeeklyColumnProgress.vue?vue&type=style&index=0&id=d135ca36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d135ca36",
  null
  
)

export default component.exports